export const toJsDateIfTs = (v: any) => {
  if (!v) return v;
  if (v instanceof Date) return v;
  if (typeof (v as any).toDate === 'function') return (v as any).toDate(); // Firestore Timestamp
  if (typeof (v as any).seconds === 'number') return new Date((v as any).seconds * 1000);
  if (typeof (v as any)._seconds === 'number') return new Date((v as any)._seconds * 1000);
  return v;
};